import { httpClient } from "../http-client";
import type { ApiResponse } from "../../../shared/types/api";
import type {
  AdminAutoConfirmCompany,
  AutoConfirmRevenue,
} from "../../../domain/types/bank-transfer-auto-confirm";

const base = "/api/admin/bank-transfer-auto-confirm";

class BankTransferAutoConfirmAdminApiService {
  /**
   * 매출 통계. **한 번에 화면 전체를 받는다** —
   * 상단·추이·회사별을 따로 부르면 새로고침마다 서로 다른 시점의 숫자가 섞인다.
   */
  async revenue(months = 12): Promise<AutoConfirmRevenue> {
    const response = await httpClient.get<ApiResponse<AutoConfirmRevenue>>(
      `${base}/revenue`,
      { params: { months } },
    );
    return response.data.data!;
  }

  /** 회사 상세의 자동확인 탭 */
  async companyView(companyId: number): Promise<AdminAutoConfirmCompany> {
    const response = await httpClient.get<ApiResponse<AdminAutoConfirmCompany>>(
      `${base}/companies/${companyId}`,
    );
    return response.data.data!;
  }

  /**
   * 연동 회원 아이디 수정.
   *
   * 신청할 때 자동으로 확보하지만, 연동사에 담당자 계정이 여럿이면 코드가 고를 수 없다.
   * 값이 어긋나면 입금 조회가 통째로 실패하므로 사람이 고칠 길을 둔다.
   */
  async updateMemberId(
    companyId: number,
    memberId: string,
  ): Promise<AdminAutoConfirmCompany> {
    const response = await httpClient.put<ApiResponse<AdminAutoConfirmCompany>>(
      `${base}/companies/${companyId}/member-id`,
      { memberId },
    );
    return response.data.data!;
  }
}

export const bankTransferAutoConfirmAdminApiService =
  new BankTransferAutoConfirmAdminApiService();
